import { Reveal } from "../Reveal";
import { PROFESSORES } from "../../config/site";

export const Professores = () => {
  return (
    <section id="professores" data-testid="professors-section" className="relative py-24 md:py-32 bg-sand">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="font-body text-xs tracking-[0.3em] uppercase text-gold">Professores</span>
          <h2 className="font-display text-ink uppercase tracking-tight leading-[0.95] text-4xl md:text-5xl lg:text-6xl mt-5">Quem vai te ensinar</h2>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {PROFESSORES.map((prof, i) => (
            <Reveal key={prof.name} delay={i * 0.1}>
              <article data-testid={`professor-card-${i}`} className="group rounded-2xl border border-line bg-paper overflow-hidden transition-all duration-500 hover:border-gold/40 hover:shadow-[0_16px_40px_rgba(17,18,20,0.06)]">
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img src={prof.img} alt={prof.name} className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-700" />
                </div>
                <div className="p-6">
                  <h3 className="font-display text-ink uppercase tracking-[0.12em] text-xl md:text-2xl">{prof.name}</h3>
                  <p className="font-body text-gold text-sm mt-2">{prof.belt}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
